const initialState = {
  isReferralDataLoaded: false,
  dateReferralSentFromSAP: '',
  dateofSAPOrJailRelease: '',
  clinicalInformationTreatmentRecommendations: '',
  sTOPResponse: '',
  epdIcnDateRelExp: '',
  mim12Step: '',
  mim12StepLocation: '',
  epdIrydsc: '',
  receivedCBPROI: '',
  receivedSAPROI: '',
  dateReferralSenttoSAP: '',
  initialAuthNumberDays: '',
  initialAuthExpectedEndDate: '',
  countyofParoleId: '',
  drugTreatmentProgramTransitionCoordinatorId: '',
  sTOPPlacementCoordinatorId: '',
};
export default initialState;
